// 1. 导入我们的 Stdio 服务器实现
import { SoraVideoStdioServer } from '~/servers/SoraVideoStdioServer.js';

// 2. 导入我们之前打包好的"工具箱"
import { allTools } from '~/tools/index.js';

/**
 * 这是使用 Stdio 传输的主函数。
 * 它通过标准输入输出 (stdin/stdout) 与 MCP 客户端通信。
 * 这是 MCP 服务器的标准用法,适合通过 npx 或其他进程管理工具启动。
 */
async function main() {
  // 注意:对于 stdio 传输,所有日志消息都必须输出到 stderr,
  // 因为 stdout 被用于 MCP 协议通信
  console.error('====================================');
  console.error('🎬 Starting Sora Video MCP Server (Stdio Mode)...');
  console.error('====================================');

  // 3. 创建一个 Stdio 服务器实例
  const server = new SoraVideoStdioServer();

  // 4. 加载工具:遍历我们的"工具箱",把每一个工具都注册到服务器里
  for (const tool of allTools) {
    server.registerTool(tool);
  }

  console.error(`[Main] ${allTools.length} tools have been registered.`);

  // 5. 启动服务器!
  //    这将连接 stdin/stdout 并开始监听 MCP 协议消息。
  try {
    await server.start();

    // 6. 设置优雅关闭处理
    // 当进程收到终止信号时,优雅地关闭服务器
    process.on('SIGINT', async () => {
      console.error('\n[Main] Received SIGINT, shutting down gracefully...');
      await server.stop();
      process.exit(0);
    });

    process.on('SIGTERM', async () => {
      console.error('\n[Main] Received SIGTERM, shutting down gracefully...');
      await server.stop();
      process.exit(0);
    });
  } catch (error) {
    console.error('[Main] A fatal error occurred during server startup:', error);
    process.exit(1); // 如果启动失败,程序退出
  }
}

// 7. 执行主函数,让一切运转起来!
main();
